<template>
    <div>
        <a-drawer
          title=""
          placement="bottom"
          :closable="true"
          :visible="visible"
          :mask="false"
          :maskClosable="false"
          :height="240"
          :destroyOnClose="true"
          wrapClassName="detailsWrap"
          @close="onClose"
        >
            <div class="details-box">
                <a-tabs type="card">
                  <a-tab-pane tab="人员信息" key="1">
                     <a-form class='ant-advanced-search-form' layout="inline">
                         <a-row :gutter="24">
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">姓名：刘三姐</p>
                                <p class="details-p">性别：女</p>
                                <p class="details-p">出生日期：2000/10/10</p>
                                <p class="details-p">电话：12365478932</p>
                                <p class="details-p">地址：成都市高新区</p>
                           </a-col>
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">紧急联系人：xxx</p>
                                <p class="details-p">紧急联系电话：12365478912</p>
                                <p class="details-p">当前状态：在线</p>
                                <p class="details-p">注册时间：2012/12/10</p>
                           </a-col>
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">机构：机构1</p>
                                <p class="details-p">组别：严管</p>
                                <p class="details-p">入组时间：21天</p>
                           </a-col>
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <a href="javascript:;" @click="editUserInfo"><img src="../../assets/edit_icon.png" alt="" /></a>
                           </a-col>
                         </a-row>
                     </a-form>
                  </a-tab-pane>
                  <a-tab-pane tab="设备信息" key="2">
                    <a-form class='ant-advanced-search-form' layout="inline">
                         <a-row :gutter="24">
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">IMEI：123654789101236542</p>
                                <p class="details-p">型号：Z50</p>
                                <p class="details-p">软件版本：V1.2</p>
                                <p class="details-p">表带长度：L</p>
                           </a-col>
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">IMSI：123654789102020104</p>
                                <p class="details-p">ICCID：123456789405789756</p>
                                <p class="details-p">套餐类型：套餐A</p>
                                <p class="details-p">剩余时间：3个月</p>
                           </a-col>
                           <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                                <p class="details-p">厂商：厂商12</p>
                                <p class="details-p">机构：机构A</p>
                                <p class="details-p">生产日期：2018/10/10</p>
                           </a-col>
                         </a-row>
                     </a-form>
                  </a-tab-pane>
                  <a-tab-pane tab="健康" key="3">
                      <z-health-line></z-health-line>
                  </a-tab-pane>
                  <a-tab-pane tab="告警" key="4">
                     <a-tabs type="card" class="warningTabBox">
                        <a-tab-pane tab="未处理" key="1">
                            <a-table class="warningTable" :columns="Columns" :dataSource="warningUnData" size="middle">
                                <template slot="operation" slot-scope="text,record">
                                    <a href="javascript:;" @click="warningHandle(record)">处理</a>
                                </template>
                            </a-table>
                        </a-tab-pane>
                        <a-tab-pane tab="已处理" key="2">
                             <a-table class="warningTable" :columns="Columns" :dataSource="warningOnData" size="middle">
                                 <template slot="operation" slot-scope="text,record">
                                    <span>已处理</span>
                                 </template>
                             </a-table>
                        </a-tab-pane>
                     </a-tabs>
                  </a-tab-pane>
                </a-tabs>
            </div>
            <i class="commonCircle oneCircle"></i>
            <i class="commonCircle twoCircle"></i>
            <i class="commonCircle threeCircle"></i>
            <i class="commonCircle fourCircle"></i>
            <i class="commonCircle fiveCircle"></i>
        </a-drawer>
    </div>
</template>    
<script>
    import config from '@/config'
    import moment from 'moment'
    import 'moment/locale/zh-cn';
    moment.locale('zh-cn');

    import BMap from 'BMap'
    import ZHealthLine from '@/components/common/HealthLine.vue'

    export default {
        name: 'ZDetailsDrawer',
        data() {
            return {
                visible: false,
                Columns:[
                     {
                        title: '',
                        dataIndex: 'userName',
                        scopedSlots: { customRender: 'userName' },
                      }, {
                        title: '',
                        dataIndex: 'userCross',
                        scopedSlots: { customRender: 'userCross' },
                      }, {
                        title: '',
                        dataIndex: 'userTime',
                        scopedSlots: { customRender: 'userTime' },
                      }, {
                        title: '',
                        dataIndex: 'userAddr',
                        scopedSlots: { customRender: 'userAddr' },
                      }, {
                        title: '',
                        dataIndex: 'userDetails',
                        scopedSlots: { customRender: 'userDetails' },
                      }, {
                        title: '',
                        dataIndex: 'operation',
                        scopedSlots: { customRender: 'operation' },
                      }
                ],
                warningUnData:[],
                warningOnData:[]
            }
        },
        components: {
            ZHealthLine
        },
        created() {
            this.initAlarm()
        },
        mounted() {

        },
        methods: {
            initAlarm(){
                 let _this = this
                 let alarmObj = {}
                 alarmObj.orgLink = "20,"
                 alarmObj.orgLinkMatchType = "||"
                 alarmObj.enetityId = "25"
                 alarmObj.minTime = 1009
                 alarmObj.maxTime = 1200
                 alarmObj.pageSize = 8
                 alarmObj.currentPage = 1
                 this.$http.post(config.api.alarm_all_url,alarmObj).then((response) => {
                       _this.alarmData = response.result
                       if(_this.alarmData.resultList.length > 0){
                          _this.alarmData.resultList.map(function(item){
                               let dataObj = {}
                               dataObj.key = item.id
                               dataObj.userName = item.uniqueSign
                               dataObj.userCross = item.alarmType
                               dataObj.userTime = _this.timeFormat(item.occurTime)
                               if (item.lng != "0" && item.lat != "0") {
                                    let point = new BMap.Point(item.lng, item.lat)
                                    let geoc = new BMap.Geocoder()
                                    geoc.getLocation(point, function (rs) {
                                        let addComp = rs.addressComponents
                                        let addrStr = addComp.street + addComp.streetNumber
                                        if (addrStr) {  
                                            dataObj.userAddr = "地址：" + addrStr + "附近"
                                        } else {                               
                                            dataObj.userAddr = "地址：" + addComp.district + "附近"
                                        }                          
                                    })
                               }else{
                                   dataObj.userAddr = "暂无地址"
                               }
                               dataObj.userDetails = "详情：" + item.message
                               if(item.status == 1){
                                  _this.warningOnData.push(dataObj)
                               }else{
                                  _this.warningUnData.push(dataObj)
                               }
                          })
                       }                       
                       // console.log(_this.alarmData)
                 }).catch((err) => {
                   console.log(err)
                 })                 
            },
            timeFormat(timestamp) {
                  return moment(timestamp * 1000).format('YYYY/MM/DD HH:mm')
            },
            // userDetailsByCarid() {
            //     this.visible = true
            // }
            onClose(){
               this.visible = false
            },
            editUserInfo() {

            },
            warningHandle(record) {
                let _this = this
                let alarmHandleData = []
                let alarmHandleObj = {}
                alarmHandleObj.id = record.key
                alarmHandleObj.annotation = '已知晓！'
                alarmHandleData.push(alarmHandleObj)
                this.$http.post(config.api.alarm_process_url,alarmHandleData).then((response) => {
                    _this.alarmData = response.result
                    _this.warningOnData.push(_this.alarmData)
                }).catch((err) => {
                    console.log(err)
                })
            }        
        }
    }
</script>